import { Suspense, useEffect } from "react";
import Routes from "./routes/Routes";
//import 'data/scss/main.css';
import "./data/css/main.css";
import ReactGA from "react-ga";
import configData from "./config.json";
import { useLocation } from "react-router-dom";
/* import { Loader } from "./helpers/loader"; */
import GlobalStyle from "./components/GlobalStyle";
import SpinnerLoaderNBC from "./components/SpinnerLoaderNBC";
/* import withClearCache from "./ClearCache"; */
import { HelmetProvider } from "react-helmet-async";

if (configData.gaConfig !== "") {
  ReactGA.initialize(configData.gaConfig);
}

export default function App() {
  let location = useLocation();
  /* const ClearCacheComponent = withClearCache(Routes); */

  useEffect(() => {
    //google analytics section
    if (configData.gaConfig !== "") {
      // console.log("location: " + location.pathname);
      ReactGA.pageview(location.pathname);
    }
  }, [location]);

  return (
    <Suspense fallback={<SpinnerLoaderNBC />}>
      <HelmetProvider>
        <GlobalStyle />
        <Routes />
      </HelmetProvider>
    </Suspense>
  );
}
